import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  deleteAssignment,
  deleteBulkAssignment,
} from 'actions/assignmentActivity/assignment_action';
import { Button, Spinner } from 'ui';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import Modal from 'ui/Modal';
import { Info } from 'react-feather';
import { Text, TEXT_VARIANTS, TEXT_COLORS } from 'ui/Typography';
import DueDatePicker from 'components/shared/DueDatePicker';
import { DATE_FORMAT } from 'actions/assign/helpers';

const ReassignmentModal = ({
  selectedIds,
  singleId,
  isVisible,
  setShowModal,
  setSelectedId,
  maximumAttempts,
}) => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(false);
  const [dueDate, setDueDate] = useState(null);

  const dismissModal = () => {
    if (singleId) setSelectedId(null);
    setShowModal(false);
  };

  const handleSubmit = () => {
    setIsSubmitting(true);
    setError(false);
    request
      .postJSON(routes.ASSIGNMENTS.BULK_MARK_REASSIGN, {
        selected_ids: selectedIds,
        due_by: dueDate && moment(dueDate).format(DATE_FORMAT),
      })
      .then(() => {
        if (singleId) {
          dispatch(deleteAssignment(singleId));
        } else {
          dispatch(deleteBulkAssignment());
        }
        setIsSubmitting(false);
        dismissModal();
      })
      .catch(e => {
        setIsSubmitting(false);
        console.error(e);
        setError(true);
      });
  };

  return (
    <Modal
      shown={isVisible}
      onDismiss={dismissModal}
      canClickAway={false}
      className="w-250 Modal-shell"
      enableFloatingDismiss
    >
      <Modal.Content>
        <div>
          <div className="d-f fd-c">
            <Text variant={TEXT_VARIANTS.TITLE} className="mb-4 tt-c">
              {t('assignments.reassignment_popup.title')}
            </Text>
            {error && (
              <div className="errorBackground mt-16">
                <div className="d-f fd-r ai-fs mb-12 mt-12">
                  <Info className="mr-8 ml-10 c-error-dark is-16" size={17} />
                  <Text
                    variant={TEXT_VARIANTS.INSTRUX_ERROR}
                    color={TEXT_COLORS.ERROR_DARK}
                  >
                    {t('assignments.reassignment_popup.error')}
                  </Text>
                </div>
              </div>
            )}
            <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="mt-20 mb-4">
              {t('assignments.reassignment_popup.message', {
                max_attempts: maximumAttempts,
              })}
            </Text>
            <div className="AssignModal-formBlockHeader mt-20">
              <h4 className="AssignModal-subtitle llui-text-body-bold">
                Due Date (optional)
              </h4>
            </div>
            <div className="AssignModal-dateField">
              <DueDatePicker onChange={setDueDate} />
            </div>
          </div>
        </div>
        <div className="d-f jc-e mt-24">
          <Button className="mr-8 tt-c" type="button" onClick={dismissModal}>
            {t('common.cancel')}
          </Button>
          <Button
            className="tt-c"
            type="button"
            customColor
            onClick={handleSubmit}
          >
            {isSubmitting && <Spinner className="mr-16" />}
            {t('assignments.reassign')}
          </Button>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default ReassignmentModal;
